var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true,"color":"#beabff"},on:{"update:active":function($event){_vm.loading=$event}}}),(!_vm.loading)?_c('div',[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }